import { Link } from "react-router-dom";
import { BloqLogo } from "@/components/brand/BloqLogo";
import { ArrowLeft } from "lucide-react";

export default function LegalLayout({ title, updated, contactEmail = "privacy@bloqtalk.app", children, testid }) {
  return (
    <div className="min-h-screen bg-bloq-bg text-white" data-testid={testid}>
      <header className="sticky top-0 z-20 border-b border-white/8 bg-bloq-bg/85 backdrop-blur-xl">
        <div className="mx-auto flex max-w-4xl items-center justify-between px-5 py-4 sm:px-8">
          <Link to="/" data-testid="legal-home-link">
            <BloqLogo size={26} textClass="text-base" />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-bloq-muted transition-colors hover:text-white"
            data-testid="legal-back-link"
          >
            <ArrowLeft className="h-4 w-4" /> Back to home
          </Link>
        </div>
      </header>

      <main className="mx-auto max-w-3xl px-5 py-12 sm:px-8">
        <p className="mb-3 text-xs font-bold uppercase tracking-[0.22em] text-bloq-mint">
          BLOQ Talk · Legal
        </p>
        <h1 className="text-3xl font-bold sm:text-4xl">{title}</h1>
        {updated && <p className="mt-3 text-sm text-bloq-muted" data-testid="legal-effective">Effective: {updated}</p>}

        <div className="legal-body mt-10 space-y-8 text-[15px] leading-relaxed text-white/80">
          {children}
        </div>

        <div className="mt-14 border-t border-white/8 pt-6 text-sm text-bloq-muted">
          Questions? Contact us at{" "}
          <a href={`mailto:${contactEmail}`} className="text-bloq-mint hover:underline" data-testid="legal-contact-email">
            {contactEmail}
          </a>
          . See also our{" "}
          <Link to="/terms" className="text-bloq-mint hover:underline">
            Terms of Service
          </Link>
          ,{" "}
          <Link to="/privacy" className="text-bloq-mint hover:underline">
            Privacy Policy
          </Link>{" "}
          and{" "}
          <Link to="/data-security" className="text-bloq-mint hover:underline">
            Data Security
          </Link>{" "}
          and{" "}
          <Link to="/delete-account" className="text-bloq-mint hover:underline">
            Delete Account
          </Link>
          .
        </div>
      </main>
    </div>
  );
}

export function Section({ heading, children }) {
  return (
    <section>
      <h2 className="mb-3 text-xl font-semibold text-white">{heading}</h2>
      <div className="space-y-3">{children}</div>
    </section>
  );
}
